import { Outlet, useLocation } from 'react-router';
import { ErrorBoundary } from '@/components/generic/ErrorBoundary';
import { LeftNav } from '../nav/LeftNav/LeftNav';
import { LeftDrawer, LeftDrawerProvider } from './LeftDrawer';
import clsx from 'clsx';
import { useNavContext } from '@/providers/NavContextProvider';
import { RightDrawerProvider } from './RightDrawer';
import { Modal } from '@/components/modals/Modal';
import { Toast } from './Toast';
import { isSuperadminUser } from '@/services/CompanyService';
import { useCurrentUser } from '@/providers/CurrentUserProvider';
import { MessageBox, MessageBoxType } from './MessageBox';
import { useTranslation } from '@/hooks/useTranslation';

export function AdminLayout() {
  const { t } = useTranslation();
  const location = useLocation();
  const navContext = useNavContext();
  const currentUser = useCurrentUser();
  const isAdmin = isSuperadminUser(currentUser.currentUser);

  if (!isAdmin) {
    return (
      <MessageBox type={MessageBoxType.Error}>
        {t('global:unauthorized')}
      </MessageBox>
    );
  }

  return (
    <div className="flex h-full w-full">
      <ErrorBoundary key={location.pathname}>
        <RightDrawerProvider>
          <LeftDrawerProvider>
            <LeftNav />
            <LeftDrawer />
            <main
              className={clsx(
                'flex flex-col w-full h-screen overflow-y-auto bg-white transition-all duration-300 ease-in-out',
                navContext?.isNavCollapsed
                  ? 'pl-[0px]'
                  : 'pl-[230px] xl:pl-[280px]',
              )}
            >
              <ErrorBoundary key={location.pathname}>
                <Outlet />
              </ErrorBoundary>
            </main>
            <Modal />
            <Toast />
          </LeftDrawerProvider>
        </RightDrawerProvider>
      </ErrorBoundary>
    </div>
  );
}
